import 'es6-promise';
import 'isomorphic-fetch';
import { createAction } from 'redux-actions';
import * as config from '../../config';
import commonHelper from '../../helper/common-helper';
import { initializeAreaAdnTableProps } from '../../helper/order-helper';
import actionTypes from '../../consts/common-action-type';
import orderActionTypes from '../../consts/order-action-type';
import orderListAcionTypes from '../../consts/order-list-action-type';
import fetchHelper from '../../helper/fetch-helper';
const orderedCoupon = commonHelper.getUrlParam('orderId');
const fromPay = commonHelper.getUrlParam('fromPay');

import md5 from 'md5';

import { formatMessage } from '../../intl/helper';
import actionText from '../../intl/messages/action/part1';
// 提示信息
const setErrorMsg = (exports.setErrorMsg = createAction(actionTypes.SET_ERROR_MSG, error => error));
// 时间戳
const setTimestamp = (exports.setTimestamp = createAction('SET_TIMESTAMP', timestamp => timestamp));
// 加载时提示信息
const setLoadMsg = (exports.setLoadMsg = createAction(actionTypes.SET_LOAD_MSG, loadinfo => loadinfo));
// 获取桌台信息
const setTableList = (exports.setTableList = createAction('SET_TABLE_LIST', tablelist => tablelist));
// hash
exports.setChildView = createAction('SET_CHILDVIEW', viewHash => viewHash);
// dishMenuStatus
const setServiceStatus = (exports.setServiceStatus = createAction('SET_SERVICE_STATUS', serviceStatus => serviceStatus));

const shopId = commonHelper.getUrlParam('shopId');

// 发送验证码参数
const getSendCodeParamStr = require('../../helper/register-helper.js').getSendCodeParamStr;

// 获取个人基本信息
const setUserInfo = (exports.setUserInfo = createAction('SET_USER_INFO', userinfo => userinfo));

// 将url参数整合成字符串
const formatObjToParamStr = commonHelper.formatObjToParamStr;
// post、form方式提交数据
const getFetchPostParam = commonHelper.getFetchPostParam;

// 设置微信信息
const setWXInfo = (exports.setWXInfo = createAction('SET_WX_INFO', wxInfo => wxInfo));

// 设置支付宝信息
const setAlipayInfo = (exports.setAlipayInfo = createAction('SET_ALIPAY_INFO', alipayInfo => alipayInfo));

// 控制菜品描述详情的显示和隐藏
const setDishDescPopup = (exports.setDishDescPopup = createAction('TOGGLE_DISH_DESC', dishDesc => dishDesc));

// 控制菜品选项的显示和隐藏
const setDishDetailPopup = (exports.setDishDetailPopup = createAction('TOGGLE_DISH_DETAIL', dishDetail => dishDetail));

// 控制优惠券选择张数
const setMaxCouponNum = createAction(orderActionTypes.SET_MAX_COUPONS_NUM, prop => prop);

const setBrandInfo = (exports.setBrandCustomConfig = createAction(actionTypes.SET_BRAND_INFO, brandInfo => brandInfo));

// 订单中心业务开关接口
const setSupportBusinessTypes = createAction(orderListAcionTypes.SET_SUPPORT_BUSINESS_TYPES, supportbusinesstypes => supportbusinesstypes);

const setReceivedCouponsInfo = createAction(actionTypes.SET_RECEIVED_COUPONS_INFO, couponList => couponList);

const changeActivePurchaseBenefit = createAction(orderActionTypes.CHANGE_ACTIVE_PURCHASE_BENEFIT, changeactivepurchasebenefit => changeactivepurchasebenefit);

const confirmChosenPurchaseBenefit = createAction(orderActionTypes.CONFIRM_CHOSEN_PURCHASE_BENEFIT, purchaseBenefitId => purchaseBenefitId);

const sameCountWithOrderPurchaseBenefit = createAction(orderActionTypes.SAME_COUNT_WITH_ORDER_PURCHASE_BENEFIT, purchaseBenefitId => purchaseBenefitId);

exports.toggleSelectorCheckedStatus = createAction('TOGGLE_SELECTOR_CHECKED_SATUS', selectorCheckedStatus => selectorCheckedStatus);

// 设置最低消费
const setMinConsume = createAction('SET_SHOP_MIN_CONSUME', params => params);

// 菜品描述详情详情的显示和隐藏
exports.toggleDishDescPopup = dishData => dispatch => {
  if (dishData && location.hash === '#dish-desc') {
    dispatch(setDishDescPopup(dishData));
    return;
  }

  dispatch(setDishDescPopup(undefined));
};

// 菜品选项的显示和隐藏
exports.toggleDishDetailPopup = dishData => dispatch => {
  if (dishData) {
    dispatch(setDishDetailPopup(dishData));
    return;
  }

  dispatch(setDishDetailPopup(undefined));
};

// 发送验证码
exports.sendCode = (phoneNum, nationTelCode, callBack) => (dispatch, getStates) => {
  const codeObj = Object.assign({}, { shopId, mobile: phoneNum, nationTelCode, timestamp: new Date().getTime() });
  const paramStr = getSendCodeParamStr(codeObj);
  const sendCodeURl = `${config.sendCodeAPI}?${paramStr}`;
  fetchHelper.get(sendCodeURl, null, { enableDefaultResponseResolve: false }).then((response = {}) => {
    const res = response.data;
    if (res.code === '200') {
      dispatch(setErrorMsg(formatMessage(actionText.actionsendVerifyCodeSuccess)));
      dispatch(setTimestamp(res.data.timeStamp));
      if (callBack) {
        callBack();
      }
    } else if (res.code === '10100') {
      dispatch(setErrorMsg(res.msg));
      setTimeout(() => location.reload(true), 1500);
    } else {
      dispatch(setErrorMsg(res.msg));
    }
  });
};

// 获取个人信息资料
exports.getUserInfo = id => (dispatch, getStates) => {
  dispatch(setLoadMsg({ status: true, word: formatMessage(actionText.actionLoading) }));
  if (!shopId) {
    dispatch(setErrorMsg(formatMessage(actionText.actioncannotFindShopId)));
    return;
  }
  fetch(`${config.individualAPI}?shopId=${shopId}`, config.requestOptions)
    .then(res => {
      if (!res.ok) {
        dispatch(setErrorMsg(formatMessage(actionText.actiongetPersonalInfoFailed)));
      }
      return res.json();
    })
    .then(basicData => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      if (basicData.code !== '200') {
        dispatch(setErrorMsg(basicData.msg));
        setTimeout(() => {
          if (basicData.code === 'NOT_LOGIN') {
            location.href = `${config.logUrl}?shopId=${shopId}&returnUrl=${encodeURIComponent(window.location.pathname + window.location.search)}`;
          }
        }, 1500);
        return;
      }
      // console.log(basicData.data);
      dispatch(setUserInfo(basicData.data));
    })
    .catch(err => {
      console.info(err);
    });
};

// 校验手机绑定验证码
exports.checkBindCode = (phoneInfo, vipCallBack, successCallBack, boundCallBack) => (dispatch, getStates) => {
  dispatch(setLoadMsg({ status: true, word: formatMessage(actionText.actionVerifying) }));
  const timestamp = getStates().timestamp || new Date().getTime();
  const paramStr = formatObjToParamStr(phoneInfo);
  const validBindMobileURL = `${config.validBindMobileAPI}?shopId=${shopId}&timeStamp=${timestamp}&${paramStr}`;

  fetchHelper.get(validBindMobileURL, null, { enableDefaultResponseResolve: false }).then((response = {}) => {
    const res = response.data;
    if (res.code === '200') {
      if (res.data.vip) {
        // 是会员
        vipCallBack();
      } else {
        // 验证成功
        successCallBack();
      }
      dispatch(setLoadMsg({ status: false, word: '' }));
    } else if (res.code === '11005') {
      // 该手机已于其他微信号绑定
      boundCallBack();
      dispatch(setLoadMsg({ status: false, word: '' }));
    } else {
      dispatch(setErrorMsg(res.msg));
      dispatch(setLoadMsg({ status: false, word: '' }));
    }
  });
};

// 绑定手机
exports.bindPhone = (phoneInfo, successCallBack) => dispatch => {
  const phoneNum = phoneInfo.phoneNum;
  const tradePassword = phoneInfo.password;
  const bindPhoneURL = `${config.bindPhoneAPI}?shopId=${shopId}`;
  const nationTelCode = sessionStorage.getItem('nationTelCode');

  const param = {
    shopId,
    mobile: phoneNum,
    nationTelCode,
  };
  if (tradePassword) {
    // 如果有交易密码
    Object.assign(param, { tradePassword: md5(tradePassword).toUpperCase() });
  }
  const requestOptions = Object.assign({}, config.requestOptions);
  requestOptions.method = 'POST';
  requestOptions.body = JSON.stringify(param);
  fetchHelper.post(bindPhoneURL, param, { enableDefaultResponseResolve: false }).then((response = {}) => {
    const res = response.data;
    if (res.code === '200') {
      successCallBack(res.data);
    } else if (res.code === '11006') {
      // 自有公众号和客如云公众号数据合并
      const needDataRecovery = true;
      successCallBack({}, needDataRecovery);
      dispatch(setLoadMsg({ status: false, word: '' }));
    } else {
      dispatch(setLoadMsg({ status: false, word: '' }));
      dispatch(setErrorMsg(res.msg));
    }
  });
};

// 绑定第三方应用信息
const handleThirdPartyBinding = (bindUrl, errorMsg, dispatch, callback) => {
  fetch(bindUrl, config.requestOptions)
    .then(res => {
      if (!res.ok) {
        dispatch(setErrorMsg(errorMsg));
      }
      return res.json();
    })
    .then(result => {
      if (result.code === '200') {
        callback();
      } else {
        dispatch(setErrorMsg(result.msg));
      }
    });
};

// 绑定微信
exports.bindWX = phoneInfo => dispatch => {
  const { phoneNum } = phoneInfo || {};
  const mobile = phoneNum || phoneInfo || ''; // 兼容phoneInfo 为phoneNum情况
  const bindWXURL = `${config.bindWXAPI}?shopId=${shopId}&mobile=${mobile}`;
  const errorMsg = formatMessage(actionText.actionbindWXFailed);

  handleThirdPartyBinding(bindWXURL, errorMsg, dispatch, () => {
    location.hash = '#wx-success';
  });
};

// 绑定支付宝
exports.bindAlipay = phoneNum => dispatch => {
  const bindAlipayUrl = `${config.bindAlipayAPI}?shopId=${shopId}&mobile=${phoneNum}`;
  const errorMsg = formatMessage(actionText.actionbindAlipayFailed);
  handleThirdPartyBinding(bindAlipayUrl, errorMsg, dispatch, () => {
    location.hash = '#alipay-success';
  });
};

// 激活会员卡流程中的绑定微信流程
exports.activateCardWithWX = (phoneInfo, callback) => dispatch => {
  const { phoneNum } = phoneInfo || {};
  const mobile = phoneNum || phoneInfo || ''; // 兼容phoneInfo 为phoneNum情况
  const bindWXURL = `${config.bindWXAPI}?shopId=${shopId}&mobile=${mobile}`;
  const errorMsg = formatMessage(actionText.actionactivateVipFailed);

  handleThirdPartyBinding(bindWXURL, errorMsg, dispatch, callback);
};

// 获取第三方应用信息
const fetchThirdPartyInfo = (url, dispatch, callback) => {
  fetch(url, config.requestOptions)
    .then(res => {
      if (!res.ok) {
        dispatch(setErrorMsg(formatMessage(actionText.actioninfoGetFailed)));
      }
      return res.json();
    })
    .then(result => {
      if (result.code === '200') {
        callback(result.data);
      } else {
        dispatch(setErrorMsg(result.msg));
      }
    });
};

// 获取微信用户信息
exports.getWXInfo = () => dispatch => {
  const url = `${config.getWXInfoAPI}?shopId=${shopId}`;
  fetchThirdPartyInfo(url, dispatch, data => {
    const headImg = data.headUrl;
    const wxName = data.name;
    const wxInfo = {
      headUrl: headImg,
      name: wxName,
      shopIdWX: shopId,
    };
    dispatch(setWXInfo(wxInfo));
  });
};

// 获取支付宝用户信息
exports.getAlipayInfo = () => dispatch => {
  const url = `${config.getAlipayInfoAPI}?shopId=${shopId}`;
  fetchThirdPartyInfo(url, dispatch, data => {
    const headImg = data.headUrl;
    const alipayName = data.name;
    const alipayInfo = {
      headUrl: headImg,
      name: alipayName,
      shopIdAlipay: shopId,
    };
    dispatch(setAlipayInfo(alipayInfo));
  });
};

// 用户退出
exports.logout = (successCallBack, faildCallBack) => () => {
  const logoutURL = `${config.logoutAPI}?shopId=${shopId}`;
  fetch(logoutURL, config.requestOptions)
    .then(res => {
      if (!res.ok) {
        faildCallBack();
      }
      return res.json();
    })
    .then(res => {
      if (res.code === '200') {
        successCallBack();
      } else {
        faildCallBack();
      }
    });
};

// 获取第三方账号的绑定状态
exports.getThirdPartyBindingStatus = () => dispatch => {
  dispatch(setLoadMsg({ status: true, word: formatMessage(actionText.actionLoading) }));
  if (!shopId) {
    dispatch(setErrorMsg(formatMessage(actionText.actioncannotFindShopId)));
    return;
  }
  fetch(`${config.individualAPI}?shopId=${shopId}`, config.requestOptions)
    .then(res => {
      if (!res.ok) {
        dispatch(setErrorMsg(formatMessage(actionText.actionrequestFailed)));
      }
      return res.json();
    })
    .then(basicData => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      if (basicData.code === '200') {
        const { data } = basicData;
        if (data.loginType === 1 && data.bindMobile) {
          // 保存电话号码到sessionStorage
          sessionStorage.mobile = data.mobile;
          location.hash = '#phone-success';
        } else if (data.loginType === 0 && data.bindWx) {
          location.hash = '#wx-success';
        } else if (data.loginType === 4 && data.bindAlipay) {
          location.hash = '#alipay-success';
        }
      }
    })
    .catch(err => {
      console.info(err);
    });
};

// 评分
exports.saveMarkRecord = (scoreInfo, successCallBack, faildCallBack) => dispatch => {
  dispatch(setLoadMsg({ status: true, word: formatMessage(actionText.actionLoading) }));
  const saveMarkRecordURL = `${config.saveMarkRecordAPI}?shopId=${shopId}`;
  scoreInfo.shopId = shopId;
  fetch(saveMarkRecordURL, getFetchPostParam(scoreInfo))
    .then(res => {
      if (!res.ok) {
        dispatch(setErrorMsg(formatMessage(actionText.actiongradeFailed)));
      }
      return res.json();
    })
    .then(res => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      if (res.code === '200') {
        successCallBack(res.data);
      } else {
        faildCallBack(res.code, res.msg);
      }
    })
    .catch(err => {
      dispatch(setLoadMsg({ status: false, word: '' }));
      console.info(err);
    });
};

// 扫码转化url为正常逻辑下的带有tableId和tabkeKey的url
exports.switchUrlBeforeGetServiceStatus = url => dispatch => {
  if (url.indexOf('z.keruyun.com') === -1) {
    return new Promise(resolve => {
      resolve(url);
    });
  }

  let str = url.split('?')[0];
  const index = str.lastIndexOf('/');
  str = str.substring(index + 1, str.length);

  return fetch(`${config.switchUrlBeforeGetServiceStatusAPI}?shopId=${shopId}&shortlink=${str}`, config.requestOptions)
    .then(res => {
      if (!res.ok) {
        dispatch(setErrorMsg(formatMessage(actionText.actionchangeUrlFailed)));
      }
      return res.json();
    })
    .then(res => {
      if (res.code !== '200') {
        return null;
      }

      return res.data;
    })
    .catch(err => {
      console.log(err.message);
    });
};

// 获取dishMenu各种状态
exports.getServiceStatus = tableInfo => dispatch => {
  const { tableId, tableKey, orderId } = tableInfo || {};
  let tableInfoStr = '';
  if (tableId || tableKey) {
    const tableStr = tableId ? 'tableId' : 'tableKey';
    tableInfoStr += `&${tableStr}=${tableId || tableKey}`;
  }
  if (orderId) {
    tableInfoStr += `&orderId=${orderId}`;
  }
  const getDishMenuStatusUrl = `${config.getServiceStatusNoTableAPI}?shopId=${shopId}${tableInfoStr}`;

  return fetchHelper
    .get(getDishMenuStatusUrl, null, { enableDefaultResponseResolve: false })
    .then((response = {}) => {
      const res = response.data;
      if (res.code === '200') {
        dispatch(setServiceStatus(res.data));
        return res.data;
      }
      return { errCode: res.code, errMsg: res.msg };
    })
    .catch((err = {}) => {
      dispatch(setErrorMsg(err.msg || formatMessage(actionText.actiongetTableInfoFailed)));
    });
};

// 获取 tableList 可用桌台
exports.getTableList = () => dispatch => {
  const orderDineInTableListURL = `${config.orderDineInTableListAPI}?shopId=${shopId}`;

  return fetch(orderDineInTableListURL, config.requestOptions)
    .then(res => {
      if (!res.ok) {
        dispatch(setErrorMsg(formatMessage(actionText.actiongetUseableTableFailed)));
      }
      return res.json();
    })
    .then(res => {
      if (res.code === '200') {
        dispatch(setTableList(res.data));
        return initializeAreaAdnTableProps(res.data.areaList);
      }
      return null;
    });
};
// Fintech Ad
exports.getFintechActivity = (obj, successCallBack) => dispatch => {
  const requestOptions = Object.assign({}, config.requestOptions);
  requestOptions.method = 'POST';
  requestOptions.body = JSON.stringify(obj);

  return fetch(`https://${config.getFintechActivity}`, requestOptions)
    .then(res => {
      if (!res.ok) {
        dispatch(setErrorMsg(formatMessage(actionText.actiongetInterfaceFailed)));
      }

      return res.json();
    })
    .then(res => {
      if (JSON.stringify(res.status) === '1000') {
        return res.content;
      }

      dispatch(setErrorMsg(res.msg));
    });
};

exports.getMaxCouponNum = () => dispatch => {
  fetchHelper
    .get(config.getBrandCouponNum, { shopId })
    .then(res => {
      dispatch(setMaxCouponNum(res));
    })
    .catch((err = {}) => {
      dispatch(setErrorMsg(err.msg));
    });
};

const fetchBrandInfo = (exports.fetchBrandInfo = () => dispatch => {
  return fetchHelper.get(config.brandInfoAPI, { shopId }).then(res => {
    dispatch(setBrandInfo(res));
    return res;
  });
});

// 订单中心业务开关接口
exports.getSupportBusinessTypes = () => (dispatch, getStates) => {
  fetchHelper
    .get(config.supportBusinessTypesAPI, { shopId })
    .then(res => {
      if (res) {
        dispatch(setSupportBusinessTypes(res));
      }
    })
    .catch((err = {}) => {
      dispatch(setErrorMsg(err.msg || formatMessage(actionText.actionOrderCenterFailed)));
    });
};

// 修改所选择的加价购的分数
exports.changeActivePurchaseBenefit = (newCount, chosenActivityDish) => (dispatch, getStates) => {
  dispatch(changeActivePurchaseBenefit({ newCount, chosenActivityDish }));
};

// 选定加价购菜品
exports.confirmChosenPurchaseBenefit = purchaseBenefitId => (dispatch, getStates) => {
  dispatch(confirmChosenPurchaseBenefit(purchaseBenefitId));
};

// 统一count和order里面的数据
exports.sameCountWithOrderPurchaseBenefit = purchaseBenefitId => (dispatch, getStates) => {
  dispatch(sameCountWithOrderPurchaseBenefit(purchaseBenefitId));
};

// 优惠券多个场景默认展示的请求
exports.getReceivedCouponsInfo = ({ consumeType }) => (dispatch, getStates) => {
  if (!orderedCoupon && !fromPay) {
    return;
  }

  dispatch(fetchBrandInfo()).then(data => {
    if (!data) {
      return;
    }
    const { brandId } = data;

    fetchHelper.post(`${config.couponReceivedInfoAPI}?shopId=${shopId}`, { shopId, orderId: orderedCoupon, consumeType, brandId }).then(res => {
      if (!res) {
        return;
      }

      dispatch(setReceivedCouponsInfo(res));
    });
  });
};

exports.getMinConsumeConf = () => dispatch => {
  fetchHelper
    .get(`${config.getShopMinConsumeConfAPI}?shopId=${shopId}`)
    .then(res => {
      dispatch(setMinConsume(res));
    })
    .catch(err => {
      console.log(err);
    });
};

exports.getPayForGiftCoupon = callback => () => {
  const params = {
    orderId: orderedCoupon,
    commercialId: shopId,
  };
  const requestUrl = `${config.getPayForGiftCoupon}?orderId=${orderedCoupon}&commercialId=${shopId}`;
  fetchHelper
    .get(requestUrl, params)
    .then(res => {
      callback(res);
    })
    .catch(error => {
      console.log(error);
      callback(error);
    });
};
exports.getNowPayForGift = callback => () => {
  const params = {
    orderId: orderedCoupon,
    commercialId: shopId,
  };
  const requestUrl = `${config.getNowPayForGiftCoupon}`;
  fetchHelper
    .post(requestUrl, params)
    .then(res => {
      callback(res);
    })
    .catch(error => {
      console.log(error);
      callback(error);
    });
};



// WEBPACK FOOTER //
// ./src/action/common-action/common-action.js